import React, { FC } from 'react';
import { getUserLang } from '@mb/lib';
import type { Event } from '@mb/types';
import { useIntl } from 'react-intl';
import { getDateFormatted } from '../../../Events/helpers/getDateFormatted';
import { definedTranslation } from '../../i18n';

interface EventContentProps {
  event: Event;
}

export const EventContent: FC<EventContentProps> = ({ event }) => {
  if (!event) return null;
  const intl = useIntl();
  const titleAbout = intl?.formatMessage(definedTranslation.title.about);
  const labelWhen = intl?.formatMessage(definedTranslation.label.when);
  const labelWhere = intl?.formatMessage(definedTranslation.label.where);
  const btnLabel = intl?.formatMessage(definedTranslation.btnSpot);
  const userLang = getUserLang();
  return (
    <div className="event-content-wrapper w-full flex flex-col justify-between justify-between gap-[64px] lg:flex-row">
      <div className="event-about flex flex-col gap-8 self-stretch lg:w-1/2">
        <h2 className="event-about-title text-lg font-bold lg:text-xl">
          {titleAbout}
        </h2>
        <div
          className="event-about-text"
          dangerouslySetInnerHTML={{ __html: event.description }}
        ></div>
      </div>
      <div className="event-card w-full flex flex-col p-2 gap-6 flex-shrink-0 rounded-[20px] bg-[#F5F5F6] lg:w-[427px]">
        <img
          className="event-card-image w-full h-[200px] object-cover rounded-[16px] gap-2.5"
          alt={event.title + ' Image'}
          src={event.thumb_image}
        />
        <div className="event-card-text flex flex-col self-stretch justify-end p-6 pt-0 gap-4">
          <div>
            <h3 className="event-card-title text-lg md:text-lgg font-bold">
              {event.title}
            </h3>
            <p className="event-card-subtitle text-mbgray-200 m-0 md:text-lg">
              {event.subtitle}
            </p>
          </div>
          <div className="event-card-info flex flex-col p-6 gap-4 self-stretch bg-white rounded-lg">
            <div className="event-card-when flex flex-col gap-1 self-stretch">
              <p className="event-card-label font-bold m-0">{labelWhen}</p>
              <p className="event-card-date text-smr text-mbgray-300 m-0">
                {getDateFormatted(event, userLang)}
              </p>
            </div>
            <div className="event-card-where flex flex-col gap-1 self-stretch">
              <p className="event-card-label font-bold m-0">{labelWhere}</p>
              <p className="event-card-locale text-smr text-mbgray-300 px-3 py-1 bg-mbgray-110 rounded-2xl w-[fit-content] m-0">
                {event.country}
              </p>
            </div>
            <div className="event-card-address text-smr text-mbgray-300">
              <div
                dangerouslySetInnerHTML={{
                  __html: event.address,
                }}
              ></div>
            </div>
          </div>
          <a
            className="btn btn-primary event-card-btn justify-center"
            href={event.url}
          >
            {btnLabel}
          </a>
        </div>
      </div>
    </div>
  );
};
